import React from "react";
import { Outlet } from "react-router-dom";
import ShootingStars from "../components/ShootingStars";

const PublicRouteLayout = ({ minifiedVersion }) => {
  return (
    <>
      <div className="h-100 d-flex ">
        <ShootingStars width={minifiedVersion ? 30 : 300} />

        <div className="flex-grow-1">
          {minifiedVersion ? (
            <div className="text-dark d-flex pt-2 pl-1">
              <img
                src={process.env.PUBLIC_URL + "/atm-logo.png"}
                width="80px"
              />{" "}
              <h6 className="mid ml-2 mb-0">Request For Quote</h6>
            </div>
          ) : (
            <div className="text-center mt-4 py-2 text-dark">
              <img
                src={process.env.PUBLIC_URL + "/atm-logo.png"}
                width="180px"
              />
            </div>
          )}
          <hr className="my-1" />

          <Outlet />
        </div>
      </div>
    </>
  );
};

export default PublicRouteLayout;
